module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/user/user.component.html
// module id = ./src/app/ultilities/user/user.component.html
// module chunks = main